<template>
  <div class="parent">
    <ul class="ul-init">
      <li
        :key="item.index"
        v-for="item in flowData"
        :class="{ active: item.index === checkedIndex }"
        @click="itemClick(item.index)"
      >
        <span>{{ item.desc }}</span>
        <div></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localHeight: 0,
      speed: 100,
      nextHeight: 0,
      checkedIndex: 0,
    };
  },
  props: {
    flowData: {
      type: Array,
      default: () => [],
    },
    baseHeight: {
      type: Number,
      default: 1381,
    },
    localItemIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    localItemIndex(newValue) {
      this.checkedIndex = newValue;
    },
  },
  created() {},
  methods: {
    itemClick(index) {
      this.checkedIndex = index;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.localHeight = localHeight;
      let nextHeight =
        this.baseHeight +
        document.querySelector(".divOffsetParent").children[index].offsetTop;
      this.nextHeight = nextHeight;
      if (localHeight > nextHeight) {
        this.smoothUp();
      } else {
        this.smoothDown();
      }
    },
    smoothDown() {
      if (this.localHeight < this.nextHeight) {
        this.localHeight += this.speed;
        document.body.scrollTop = this.localHeight;
        document.documentElement.scrollTop = this.localHeight;
        setTimeout(this.smoothDown, 10);
      } else {
        document.body.scrollTop = this.nextHeight;
        document.documentElement.scrollTop = this.nextHeight;
      }
    },
    smoothUp() {
      if (this.localHeight - this.nextHeight > this.speed) {
        this.localHeight -= this.speed;
        document.body.scrollTop = this.localHeight;
        document.documentElement.scrollTop = this.localHeight;
        setTimeout(this.smoothUp, 0);
      } else {
        document.body.scrollTop = this.nextHeight;
        document.documentElement.scrollTop = this.nextHeight;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../scss/flowWidget.scss";
</style>
